import { initViewMode } from '@/javascripts/editor/init_view_mode';
import { bindCustomLinkMenuEvent } from '@/javascripts/custom_link_menu';
import Mute from '@/javascripts/components/Mute';

if (!window?.Coorum) {
  window.Coorum = {};
}
window.Coorum.Mute = Mute;

document.addEventListener('DOMContentLoaded', () => {
  const $ = (window as Window & { jQuery?: JQueryStatic }).jQuery;
  if (!$) return;

  initViewMode();
  bindCustomLinkMenuEvent(document);
  // カテゴリの class activeを変更
  document.querySelectorAll('.p-top--item li').forEach((target) => {
    target.addEventListener('click', function (e) {
      Community.changeCategory(e.currentTarget as HTMLElement);
    });
  });

  new Mute().addToggleMuteEvent();
});

const Community = {
  changeCategory: function (ele: HTMLElement) {
    document.querySelectorAll('.p-top--item li').forEach((target) => {
      target.classList.remove('active');
    });
    ele.classList.add('active');
  },
};
